module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE2IDE3Ij4KICAgIDxwYXRoIGZpbGw9IiMyQzJDMkMiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcuNzcgMTYuOTExbC0yLjU2LTIuMzcuNDU0LS40MjEgMi4wMTYgMS44Njd2LTMuNzI4SDB2LS41OTJoMTZ2LjU5Mkg4LjMydjMuNzI4bDIuMDE2LTEuODY3LjQ1NC40Mi0yLjU2IDIuMzcxYS4zNDMuMzQzIDAgMCAxLS40NiAwem0uNTQ0LTExLjE3VjIuMDEzTDEwLjMzIDMuODhsLjQ1NC0uNDItMi41Ni0yLjM3MWEuMzM1LjMzNSAwIDAgMC0uNDU0IDBsLTIuNTYgMi4zNy40NTQuNDIxTDcuNjggMi4wMTN2My43MjhIMHYuNTkyaDE2di0uNTkySDguMzE0eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drag-and-drop-icon.svg
// module id = 228
// module chunks = 0